export default __webpack_public_path__ + "static/media/BDO.fbfb994a.png";